import { render, staticRenderFns } from "./sheetCaracteristics.vue?vue&type=template&id=c8e27ca8&scoped=true"
import script from "./sheetCaracteristics.vue?vue&type=script&lang=js"
export * from "./sheetCaracteristics.vue?vue&type=script&lang=js"
import style0 from "./sheetCaracteristics.vue?vue&type=style&index=0&id=c8e27ca8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e27ca8",
  null
  
)

export default component.exports